import React from 'react';
import './App.css';
import ProductList from './components/ProductList';
import { Routes, Route } from "react-router";
import Header from './components/Header';
import ProductDetail from './pages/ProductDetail';


function App() {
  return (
    <div className="App">
      <Header/>
      <Routes>
        <Route path="/" element={<ProductList />} />        
        <Route path="/product/:id" element={<ProductDetail />} />
      </Routes>      
    </div>
  );
}

export default App;
